import { ProfilePageRoute } from '@/App/AppRoutes/ProfilePageRoute';
import { ProtectedLayoutRouteBase } from '@/App/AppRoutes/ProtectedLayoutRouteBase';
import type { AppRouteConfig } from '@/App/AppRoutes/types';

export const ProtectedLayoutRoute: AppRouteConfig = {
  ...ProtectedLayoutRouteBase,
  children: [ProfilePageRoute],
};
